/**
 * ARTIST DASHBOARD ROUTES
 * * ROUTE FILE NAME NEED SAME WITH REAL PATH! EXCEPT HOME
 */
import artistRoutes from './artist-routes.js';
import artistMetadataImportRoutes from './artist-metadata-import.js';
import routeConst from './const.js';

const allArtistChildrenRoutes = artistRoutes.concat(artistMetadataImportRoutes);

export default [
  {
    path: '/:lang?/artist',
    component: () => import(
      /* webpackChunkName: "artist-console" */
      '@/views/artist/ArtistConsole.vue'
    ),
    children: allArtistChildrenRoutes,
  },
  {
    path: '/:lang?/artist/elements/edit/:elementId',
    alias: '/:lang?/artist/elements/editor/:elementId', // temp for transition
    name: routeConst.ARTIST_ELEMENT_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-elements-edit" */
      '@/views/artist/element/edit/Edit.vue'
    ),
  },
  {
    path: '/:lang?/artist/collections/edit/:collectionId',
    alias: '/:lang?/artist/collection/edit/:collectionId', // temp for transition
    name: routeConst.ARTIST_COLLECTION_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-collections-edit-page" */
      '@/views/artist/collection/edit/EditPage.vue'
    ),
  },
  {
    path: '/:lang?/artist/page/edit',
    name: routeConst.ARTIST_PROFILE_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-page-edit-page" */
      '@/views/artist/page/EditProfilePage.vue'
    ),
  },
];
